import React from "react";
import "../../styles/SalesFunnel.css";
import awareness from "../../assets/icons/front-end.png";
import conversion from "../../assets/icons/web-programming.png";
import retention from "../../assets/icons/responsive.png";
import analytics from "../../assets/icons/ecommerce.png";
import testing from "../../assets/icons/cms.png";
import optimization from "../../assets/icons/optimize.png";

const SFservice = () => {
  return (
    <div className="sf-services">
      <h3>Lead Generation Services</h3>
      <p className="sf-description">
        Grow your commercial enterprise with our result-driven{" "}
        <b>lead generation services</b> designed to attract, engage, and convert
        fantastic possibilities into loyal customers. We use a mixture of
        facts-driven strategies, advanced gear, and verified advertising
        strategies to deliver constant and scalable leads on your business.
      </p>

      <div className="sf-cards-wrapper">
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={awareness} alt="Awareness Stage" />
          </div>
          <h3>High-Converting Landing Pages</h3>
          <p>
            We create high-converting landing pages with persuasive layout,
            clean messaging, and strong CTAs that flip site visitors into
            certified leads constantly.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={conversion}
              alt="Conversion Optimization"
            />
          </div>
          <h3>Strategic Lead Capture Forms</h3>
          <p>
            We design clever lead seize bureaucracy that acquire crucial
            consumer statistics at the same time as preserving simplicity,
            enhancing conversions, and improving basic user enjoy.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={retention}
              alt="Customer Retention"
            />
          </div>
          <h3>Content-Driven Lead Generation</h3>
          <p>
            We develop SEO-friendly content strategies, including blogs and
            articles, to attract targeted audiences, increase traffic, and
            generate high-quality organic leads consistently.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={analytics} alt="Funnel Analytics" />
          </div>
          <h3>Paid Advertising Campaigns</h3>
          <p>
            We run targeted paid advertising campaigns on Google and social
            media systems to drive on the spot visitors, maximize reach, and
            generate high-motive leads.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={testing} alt="A/B Testing" />
          </div>
          <h3> Email Lead Nurturing</h3>
          <p>
            We create computerized electronic mail nurturing campaigns that have
            interaction potentialities, build trust, and manual capacity
            customers via the funnel to growth conversions efficaciously.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={optimization}
              alt="Advanced Optimization"
            />
          </div>
          <h3> Lead Tracking & Analytics</h3>
          <p>
            We use superior analytics gear to music lead performance, measure
            campaign achievement, and optimize techniques for higher ROI and
            steady increase outcomes.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={optimization}
              alt="Advanced Optimization"
            />
          </div>
          <h3>Advanced Lead Nurturing</h3>
          <p>
            We put in force advanced nurturing strategies the use of automation
            and remarketing to re-engage cold leads, construct relationships,
            and convert them into loyal customers.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SFservice;
